import React, { Suspense } from 'react';
import { Title, Wrapper, Content } from './empty-state.styled';
export const EmptyState = ({
  title,
  content,
  Image
}) => /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Image, null), /*#__PURE__*/React.createElement(Title, null, title), /*#__PURE__*/React.createElement(Content, null, content)));